export default __webpack_public_path__ + "static/media/berat.95a99c0f.png";